import React from 'react'
import _cx from 'classnames/bind'
import Text from '../../elementals/text'
import Animate from '../../elementals/animate'
import type {
  CognitionEvaluationGroupMessage,
  CognitionEvaluationChatInputMessage,
  CognitionEvaluationDslGenerationInputMessage,
} from '@adc/sdk/types'
import cls from './styles.scss'

const cx = _cx.bind(cls)

export interface CognitionChatInputMessageProps {
  message:
    | CognitionEvaluationChatInputMessage
    | CognitionEvaluationDslGenerationInputMessage
  index: number
  isVisible?: boolean
  elmId?: string
}

const CognitionChatInputMessage: React.FC<CognitionChatInputMessageProps> = ({
  message,
  index,
  isVisible = true,
  elmId = 'cognition-message',
}) => {
  /**
   * Not sure why we handle message differently between these two, but for now we'll
   * just deal with it.
   */
  const msg =
    (message as CognitionEvaluationGroupMessage).__typename ===
    'CognitionEvaluationDSLGenerationInputMessage'
      ? (message as CognitionEvaluationDslGenerationInputMessage).message
      : (message as CognitionEvaluationChatInputMessage).object?.message || ''
  return (
    <Animate.FadeInOut
      key={`${message.sequence}-user`}
      isVisible={isVisible}
      duration={500}
    >
      <div
        className={cx('message', 'user')}
        data-elm-id={`${elmId}_container_${index}`}
      >
        <div
          className={cx('message-bubble', 'user')}
          data-elm-id={`${elmId}_bubble_${index}`}
        >
          <Text size='small' color='inherit'>
            {msg}
          </Text>
        </div>
      </div>
    </Animate.FadeInOut>
  )
}

export default CognitionChatInputMessage
